import store from '@/store/store';
import { getAll } from '@/api/produit/produitLocation';
import * as resProduitLoc from '@/configuration/excel/excelSMConf';
import { SOCIETE_PUBLID_ID } from '@/configuration/societe/societe';

export function getSocietePublid() {
  return store.getters['societe/societesInformations']?.find(s => s.id === SOCIETE_PUBLID_ID);
}

export async function getProduitLocForImportNum() {
  const societe = getSocietePublid();
  if (!societe) throw new Error();
  const produitsLocFull = (
    await getAll(
      {
        query:
          {
            actif: null,
            auto: resProduitLoc.PRODUIT_LOCATION_REFERENCE_NUM_FULL_UNITE,
            societeId: societe.id,
          },
      },
    )
  ).data.result.items;
  if (produitsLocFull.length === 0) throw new Error();
  return produitsLocFull[0];
}
